import NeonHero from '../../components/NeonHero';
import FinancingBanner from '../../components/FinancingBanner';

export default function Body() {
	return (
		<div>
			<NeonHero
				title="Body & Paint"
				subtitle="From dent repair to full refinish. Streamlined estimating and parts sourcing."
				primaryCta={{ label: 'Start Estimate', href: 'https://realm.ubiquityauto.com/order/2dcf3188-0a07-4444-b5f8-065a5dc238bb?access_token=_ha6LYxaO-9HjbYZVCY7P21vuKFFRaQ5' }}
			/>

			<FinancingBanner />

			<section className="container py-12">
				<h2 className="text-2xl font-bold">What we do</h2>
				<ul className="mt-4 grid sm:grid-cols-2 gap-3 text-gray-700 list-disc list-inside">
					<li>Paintless dent repair</li>
					<li>Bumpers, panels, lighting</li>
					<li>Color matching and refinishing</li>
					<li>Insurance coordination</li>
				</ul>
				<div className="mt-10 grid md:grid-cols-3 gap-6">
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Process</h3>
						<ol className="mt-2 list-decimal list-inside text-gray-700 space-y-1">
							<li>Digital estimate and teardown planning</li>
							<li>Parts sourcing and approvals</li>
							<li>Repair, refinish, blend</li>
							<li>QC and delivery</li>
						</ol>
					</div>
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Financing</h3>
						<p className="mt-2 text-gray-700">Drive Now, Pay Later – Affirm | Klarna 0% for 12 months with approved credit.</p>
					</div>
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Timeline</h3>
						<p className="mt-2 text-gray-700">Minor: same-day. Multi-panel refinish: 2–5 days.</p>
					</div>
				</div>
			</section>
		</div>
	);
}
